(function () {
    if (typeof window === 'undefined') return
    const docbooks = ['docbook.cn', 'docbook.com.cn']
    // 判断是否 docbook 域名
    const isDoc = host => docbooks.some(r => host === r || host.endsWith('.' + r))
    // 获取当前主域（docbook.cn 或 docbook.com.cn）
    const currentRoot = docbooks.find(r =>

        window.location.hostname == r || window.location.hostname.endsWith('.' + r)
    )
    // 先判断一下是不是跟当前的host一致，然后如果不一致再判断一下是不是docbook.com.cn或者docbook.cn
    function fixUrl (url) {
        try {
            const u = new URL(url, window.location.href)
            if (!currentRoot || !isDoc(u.hostname)) return url

            let sub = ''
            for (const r of docbooks) {
                if (u.hostname === r) break
                if (u.hostname.endsWith('.' + r)) {
                    sub = u.hostname.slice(0, -r.length - 1)
                    break
                }
            }
            u.hostname = sub ? sub + '.' + currentRoot : currentRoot
            return u.href
        } catch {
            return url
        }
    }

    // 自定义 location.href
    window.go = function (url) {
        console.log(fixUrl(url), 'fixUrl(url)')
        // window.location.href = fixUrl(url)
        window.location.href = url
    }
    // 2. 重写 window.open
    const _open = window.open
    window.open = (url, name, feats) => _open(url, name || '_blank', feats)
})()